/** The 3D map's chunk (three.js and the scene, the heaviest part of Explora): one import shared by whoever starts it first. */
export const loadLugarMap = () => import('@/components/client/map/LugarMap');
